export const APP_SETTINGS_TABS = {
  general: 1,
  helpAndSupport: 2
};
